const Cargando = () => {
    return (
        <div className='contenedor-cargando'>
            <div className='contenedor-cargando-center'>
                <div className=" spinner-border text-warning" role="status"></div>
            </div>
        </div>
    );
}
 
export default Cargando;